import { Button, Grid, MenuItem } from '@mui/material'
import { Field, Form, Formik } from 'formik'
import { TextField } from 'formik-material-ui'
import { isEqual } from 'lodash'
import { memo } from 'react'
import { metodoPrograma } from '../../../components/api'
import AutoComplete from '../../../components/AutoComplete/AutoComplete'
import dayjs from 'dayjs'

const retornaLocalAtendimento = (u = []) => ({
  idPlanoConta: u?.[0] || undefined,
  idEmpresa: u?.[1]?.[0]?.[0] || undefined,
  acEmpresa: u?.[1] || undefined,
  cdCodigo: u?.[2] || undefined,
  dsNome: u?.[3] || undefined,
  tpPlanoConta: u?.[4] || undefined,
  dtInclusao: u?.[5] ? dayjs(u?.[5]).format('DD/MM/YYYY HH:mm') : null,
  dtExclusao: u?.[6] ? dayjs(u?.[6]).format('DD/MM/YYYY HH:mm') : null,
})
const Edicao = ({ dados, voltar }) => {
  const salva = async (values) => {
    const res = await metodoPrograma('salva', values)
    if (res.status) voltar()
  }

  return (
    <Formik
      initialValues={retornaLocalAtendimento(dados)}
      onSubmit={async (values, { setSubmitting }) => {
        await salva(values)
        setSubmitting(false)
      }}
    >
      {({ isSubmitting, submitForm, setFieldValue }) => (
        <Form style={{ width: '100%', padding: 0 }}>
          <Grid container spacing={2}>
            <Grid item xs={3}>
              <Field
                component={TextField}
                name="cdCodigo"
                label="Código"
                fullWidth
                margin="dense"
                variant="outlined"
                size="small"
              />
            </Grid>
            <Grid item xs={9}>
              <Field
                InputLabelProps={{ shrink: true }}
                component={TextField}
                name="dsNome"
                label="Nome"
                fullWidth
                margin="dense"
                variant="outlined"
                size="small"
              />
            </Grid>
            <Grid item xs={4}>
              <AutoComplete
                InputLabelProps={{ shrink: true }}
                label="Empresa"
                metodo="buscaEmpresa"
                value={dados?.[1]}
                onChange={(_, v) => {
                  setFieldValue('idEmpresa', v?.[0]?.[0])
                  setFieldValue('acEmpresa', v)
                }}
              />
            </Grid>
            <Grid item xs={4}>
              <Field
                InputLabelProps={{ shrink: true }}
                component={TextField}
                name="tpPlanoConta"
                label="Tipo"
                fullWidth
                select
                margin="dense"
                variant="outlined"
                onChange={(event) => {
                  setFieldValue('tpPlanoConta', event.target.value)
                }}
                size="small"
              >
                <MenuItem key={0} value={'R'}>
                  Receita
                </MenuItem>
                <MenuItem key={1} value={'D'}>
                  Despesa
                </MenuItem>
              </Field>
            </Grid>
            <Grid item xs={2}>
              <Field
                InputLabelProps={{ shrink: true }}
                component={TextField}
                name="dtInclusao"
                label="Inclusão"
                fullWidth
                margin="dense"
                variant="outlined"
                disabled
                size="small"
              />
            </Grid>
            <Grid item xs={2}>
              <Field
                InputLabelProps={{ shrink: true }}
                component={TextField}
                name="dtExclusao"
                label="Exclusão"
                fullWidth
                margin="dense"
                variant="outlined"
                disabled
                size="small"
              />
            </Grid>

            <Grid
              item
              xs={12}
              style={{ display: 'flex', flexDirection: 'row-reverse' }}
            >
              <Button
                onClick={submitForm}
                disabled={isSubmitting}
                variant="contained"
                color="primary"
                style={{ margin: '5px' }}
              >
                Salvar
              </Button>
              <Button
                onClick={voltar}
                variant="contained"
                color="secondary"
                style={{ margin: '5px' }}
              >
                Cancelar
              </Button>
            </Grid>
          </Grid>
        </Form>
      )}
    </Formik>
  )
}

export default memo(Edicao, isEqual)
